<template>
	<div class="container">
		<Header></Header>
		<headerSearch></headerSearch>
		<mainTab :nindex="1"></mainTab>
		<div class="find_product">
			<!-- 筛选项 分类 种类 有效期限 -->
			<div class="select_wrap select_wrap1 w1440 fs16">
				<!-- 筛选项 -->
				<div class="flex-box flex-col-start mb15">
					<div class="select_key">筛选项</div>
					<div class="flex-grow-1 flex-box flex-wrap">
						<div class="selected_box flex-box" v-if="categoryList[current]?.name">
							<div class="key">分类：</div>
							<div class="value flex-box">
								<div>{{ categoryList[current]?.name }}</div>
								<i class="icon_del" @click="clearFirstCategoryId"></i>
							</div>
						</div>
						<div class="selected_box flex-box" v-if="categoryList[current]?.children[tabIndex]?.name">
							<div class="key">种类：</div>
							<div class="value flex-box">
								<div>{{ categoryList[current]?.children[tabIndex]?.name }}</div>
								<i class="icon_del" @click="clearSecondCategoryId"></i>
							</div>
						</div>
						<!-- <div class="selected_box flex-box">
              <div class="key fs18">期限：</div>
              <div class="value fs18 flex-box">
                <div>近一年</div>
                <i class="icon_del"></i>
              </div>
            </div> -->
					</div>
				</div>
				<!-- 分类 -->
				<div class="flex-box flex-col-start mb15">
					<div class="select_key">分类</div>
					<div class="flex-grow-1 flex-box flex-wrap">
						<div class="select_value" :class="{ active: current == -2 }" @click="switchMenu(-2)">全部</div>
						<div class="select_value" :class="{ active: current == -1 }" @click="switchMenu(-1)">热门产品</div>

						<div class="select_value" v-for="(item, index) in categoryList" :key="index" :class="{ active: current == index }" @click="switchMenu(index)">
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- 种类 -->
				<div class="flex-box flex-col-start mb25">
					<div class="select_key">种类</div>
					<div class="flex-grow-1 flex-box flex-wrap">
						<div class="select_value" :class="{ active: tabIndex == -1 }" @click="secondCategoryClick(-1)">全部</div>
						<div class="select_value" v-for="(item, index) in categoryList[current]?.children" :key="index" :class="{ active: tabIndex == index }" @click="secondCategoryClick(index)">
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- 有效期限 -->
				<!-- <div class="flex-box flex-col-start">
          <div class="select_key fs18 mt5">有效期限</div>
          <div class="flex-grow-1">
            <div class="flex-box">
              <div class="flex-box flex-grow-1 value_wrap">
                <div class="select_value fs18">全部</div>
                <div class="select_value fs18">近三个月</div>
                <div class="select_value fs18">近半年</div>
                <div class="select_value fs18 active">近一年</div>
              </div>
              <div class="btn_toggle fs18">自定义</div>
              <div class="btn_toggle fs18 active">收起</div>
            </div>
            <div class="flex-box">
              <div class="custom_box fs18">自定最早时间</div>
              <div class="line1"></div>
              <div class="custom_box fs18">自定最终时间</div>
            </div>
          </div>
        </div> -->
			</div>
			<!-- 库存数量  价格 -->
			<div class="select_wrap select_wrap2 w1440 fs16" v-if="query.sort">
				<!-- 库存数量 -->
				<div class="flex-box flex-col-start" v-if="query.sort == 'stock'">
					<div class="select_key">库存数量</div>
					<div class="flex-grow-1">
						<div class="flex-box">
							<div class="flex-box flex-grow-1 value_wrap">
								<div class="select_value" @click="clearStock">全部</div>
								<div class="select_value" :class="{ active: query.sort == 'stock' && query.order == 'desc' }" @click="sortOrder('stock', 'desc')">由多到少</div>
								<div class="select_value" :class="{ active: query.sort == 'stock' && query.order == 'asc' }" @click="sortOrder('stock', 'asc')">由少到多</div>
							</div>
							<div class="btn_toggle" @click="toggleCustomStock" v-if="!isCustomStock">自定义</div>
							<div class="btn_toggle active" @click="toggleCustomStock" v-else>收起</div>
						</div>
						<!-- 自定义 -->
						<div class="flex-box" v-if="isCustomStock">
							<input class="custom_box" type="number" v-model="query.min_stock" placeholder="自定最少数量" @blur="refresh" />
							<div class="line1"></div>
							<input class="custom_box" type="number" v-model="query.max_stock" placeholder="自定最高数量" @blur="refresh" />
						</div>
					</div>
				</div>
				<!-- 价格 -->
				<div class="flex-box flex-col-start" v-if="query.sort == 'price'">
					<div class="select_key mt5">价格</div>
					<div class="flex-grow-1">
						<div class="flex-box">
							<div class="flex-box flex-grow-1 value_wrap">
								<div class="select_value" @click="clearStock">全部</div>
								<div class="select_value" :class="{ active: query.sort == 'price' && query.order == 'desc' }" @click="sortOrder('price', 'desc')">由高到低</div>
								<div class="select_value" :class="{ active: query.sort == 'price' && query.order == 'asc' }" @click="sortOrder('price', 'asc')">由低到高</div>
							</div>
							<div class="btn_toggle" @click="toggleCustomPrice" v-if="!isCustomPrice">自定义</div>
							<div class="btn_toggle active" @click="toggleCustomPrice" v-else>收起</div>
						</div>
						<!-- 自定义 -->
						<div class="flex-box" v-if="isCustomPrice">
							<input class="custom_box" type="number" v-model="query.min_price" placeholder="自定最低价格" @blur="refresh" />
							<div class="line1"></div>
							<input class="custom_box" type="number" v-model="query.max_price" placeholder="自定最高价格" @blur="refresh" />
						</div>
					</div>
				</div>
			</div>
			<!-- 销量 价格 库存数量 -->
			<div class="rank_row">
				<div class="flex-box fs16 w1440">
					<div class="flex-box rank" :class="{ active: query.sort == 'sales' }" @click="onSort('sales')">
						<div class="">销量</div>
						<img v-if="query.sort == 'sales' && query.order == 'asc'" src="@/assets/static/icon/z_icon_rank2.png" class="icon_rank" />
						<img v-else-if="query.sort == 'sales' && query.order == 'desc'" src="@/assets/static/icon/z_icon_rank3.png" class="icon_rank" />
						<img v-else src="@/assets/static/icon/z_icon_rank1.png" class="icon_rank" />
					</div>
					<div class="flex-box rank" :class="{ active: query.sort == 'price' }" @click="onSort('price')">
						<div class="">价格</div>
					</div>
					<div class="flex-box rank" :class="{ active: query.sort == 'stock' }" @click="onSort('stock')">
						<div class="">库存数量</div>
					</div>
					<div class="flex-grow-1 tr total">
						<span>共</span>
						<span class="num">{{ goodsList.length }}</span>
						<span>件商品</span>
					</div>
				</div>
			</div>
			<!-- 商品 -->
			<div class="products_wrap w1440 flex-box flex-wrap" v-if="goodsList.length > 0">
				<div class="product_item" v-for="(goods, index1) in goodsList" :key="index1" @click="onDetail(goods.id)">
					<img :src="goods.image_text" class="img1" />
					<div class="price1 fs16" v-if="!userInfo">价格登录可见</div>
					<div v-else>
						<span class="price2 fs16" v-if="goods.min_max_price[0].min_price">¥ {{ goods.min_max_price[0].min_price + "~" + goods.min_max_price[0].max_price }}</span>
						<span class="price2 fs16" v-else>暂无价格</span>
						<span class="price3 fs14">/{{ goods.unit }}</span>
					</div>
					<div class="name m-ellipsis fs16">{{ goods.title }}</div>
					<div class="flex-box flex-col-start" style="height: 72px;">
						<div class="flex-grow-1 pr10">
							<div class="spec fs14 m-ellipsis" v-for="(params, index) in goods.params_text" :key="index" v-show="index < 3">{{ params.title }}：{{ params.content }}</div>
						</div>
						<img src="../../assets/static/icon/jj_icon_cart.png" class="icon_cart" alt="" />
					</div>
				</div>
			</div>

			<div v-if="goodsList.length == 0" class="nodata fs16 tc">
				<img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
				<div>暂无相关数据</div>
			</div>
			<!-- 分页 -->
			<div class="pagination1" v-show="total > per_page">
				<pagination :sumCount="total" :perCount="per_page" @pageTurn="pageTurn"></pagination>
			</div>

			<!-- <div class="page_wrap flex-box flex-center">
        <div class="page_item fs14 active">1</div>
        <div class="page_item fs14">2</div>
        <div class="page_item fs14">3</div>
        <div class="page_item fs14">4</div>
        <div class="page_dot fs18">…</div>
        <div class="page_item fs14">100</div>
        <div class="page_item fs14">
          <img src="@/assets/static/icon/z_icon_arrow1.png" class="icon_arrow" />
        </div>
        <div class="fs14 text_go">跳转到：</div>
        <input type="text" class="input_go" />
        <div class="btn_go fs14">GO</div>
      </div> -->
		</div>
	</div>
</template>
<script>
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	export default {
		name: "FindProduct",
		setup() {
			onMounted(() => {
				useHead({
					title: "产品商城-小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{
							property: "og:description",
							content: "This is my page description",
						},
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		data() {
			return {
				categoryList: [
					{
						children: [],
					},
				],
				current: -1, // 分类
				tabIndex: -1, //种类
				isCustomPrice: false, // 是否显示自定义价格
				isCustomStock: false, // 是否显示自定义库存
				query: {
					keyword: "",
					first_category_id: 0,
					category_id: 0,
					min_price: "",
					max_price: "",
					min_stock: "",
					max_stock: "",
					sort: "",
					order: "",
				},
				goodsList: [],
				page: 1,
				userInfo: null,
				goodsData: null,
				total: 0,
				per_page: 10,
				isLogin: false,
			};
		},
		created() {
			if (this.$cookies.get("token")) {
				this.isLogin = true;
				this.userInfo = this.$cookies.get("userinfo");
			}
			this.query.first_category_id = this.$route.query.first_category_id || 0;
			this.current = this.$route.query.first_category_index || -2;
			this.query.category_id = this.$route.query.category_id || 0;
			this.tabIndex = this.$route.query.category_index || -1;
			this.query.keyword = this.$route.query.keyword || "";
			this.refreshPage();
		},
		watch: {
			// 监听 $route.query 的变化
			"$route.query": {
				handler(newQuery) {
					// 当查询参数变化时执行的逻辑
					this.query.keyword = newQuery.keyword;
					this.query.first_category_id = newQuery.first_category_id;
					this.query.category_id = newQuery.category_id;
					this.current = newQuery.first_category_index;
					this.tabIndex = newQuery.category_index;
					this.refresh();
				},
			},
		},
		methods: {
			// 获取分类
			refreshPage() {
				//分类
				// let defaultList = [
				//   {
				//     id: 0,
				//     name: "热门产品",
				//     children: [],
				//   },
				// ];
				this.$api.GetCategoryList().then((res) => {
					if (res.code == 1) {
						// this.categoryList = defaultList.concat(res.data);
						this.categoryList = res.data;
						// 设置分类
						// for (let i = 0; i < this.categoryList.length; i++) {
						//   if (this.categoryList[i].id == this.query.first_category_id) {
						//     this.current = i;
						//     break;
						//   }
						// }
					}
				});
				this.refresh();
			},
			// 分类 切换
			switchMenu(index) {
				this.current = index;
				if (this.current == -1 || this.current == -2) {
					// 点击全部设置成默认的
					this.query.first_category_id = 0;
					this.query.category_id = 0;
					this.tabIndex = -1;
					this.refresh();
					return;
				}
				let id = this.categoryList[index].id;
				this.query.first_category_id = id;
				this.query.category_id = 0;
				// 将二级分类样式默认选中全部
				this.tabIndex = -1;
				this.refresh();
			},
			// 清除分类 恢复默认
			clearFirstCategoryId() {
				this.query.first_category_id = 0;
				this.query.category_id = 0;
				this.current = -1;
				this.tabIndex = -1;
				this.refresh();
			},
			//二级分类  种类切换
			secondCategoryClick(index) {
				this.tabIndex = index;
				let id = 0;
				if (index > -1) {
					id = this.categoryList[this.current].children[index].id;
				}
				this.query.category_id = id;
				this.refresh();
			},
			// 清除二级分类
			clearSecondCategoryId() {
				this.query.category_id = 0;
				this.tabIndex = -1;
				this.refresh();
			},
			//排序
			onSort(sort) {
				this.query.sort = sort;
				this.query.order = this.query.order == "asc" ? "desc" : "asc";
				this.refresh();
			},
			// 价格排序方式
			sortOrder(sort, order) {
				this.query.sort = sort;
				this.query.order = order;
				this.refresh();
			},
			// 是否显示自定义价格
			toggleCustomPrice() {
				this.isCustomPrice = !this.isCustomPrice;
			},
			// 是否显示自定义库存
			toggleCustomStock() {
				this.isCustomStock = !this.isCustomStock;
			},
			//
			clearStock() {
				this.query.sort = "";
				this.query.order = "";
				this.query.min_stock = "";
				this.query.max_stock = "";
				this.query.min_price = "";
				this.query.max_price = "";
				this.refresh();
			},

			// 刷新
			refresh() {
				this.goodsList = [];
				this.page = 1;
				this.fetch();
			},

			// 获取商品列表
			fetch() {
				let query = this.query;
				query.list_rows = 10;
				query.page = this.page;
				let that = this;
				that.$api
					.GetGoods(query)
					.then((res) => {
						if (res.code == 1) {
							this.goodsList = res.data.data;
							this.goodsData = res.data;
							this.total = res.data.total;
							this.per_page = res.data.per_page;
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 翻页
			pageTurn(i) {
				this.page = i + 1;
				this.fetch();
			},

			onDetail(id) {
				if (this.isLogin == false) {
					this.$router.push({
						path: "/FindProductDetail",
						query: { id, first_category_id: this.query.first_category_id },
					});
				} else {
					const routeData = this.$router.resolve({
						name: "FindProductDetail", // 目标路由的名称
						query: { id, first_category_id: this.query.first_category_id },
					});
					window.open(routeData.href, "_blank");
				}
			},
		},
	};
</script>
<style lang="less" scoped>
	.find_product {
		// padding: 0 0 100px;
		// width: 1920px;
		background-color: #fff;
	}

	.select_wrap1 {
		padding: 15px 0 0;
	}

	.select_wrap2 {
		padding: 15px 0;
		border-top: 1px solid rgba(222, 222, 222, 0.6);
	}

	.select_wrap {
		.line1 {
			margin: 0 25px;
			width: 66px;
			height: 2px;
			background: #dedede;
		}

		.custom_box {
			// padding: 0 0 0 34px;
			width: 200px;
			height: 53px;
			background: rgba(150, 150, 150, 0.06);
			border-radius: 8px;
			color: #7a8499;
			line-height: 53px;
			text-align: center;
			font-style: normal;
			cursor: pointer;
		}

		input.custom_box {
			color: #333;
		}

		.select_key {
			margin-top: 10px;
			margin-right: 30px;
			color: #909090;
			line-height: 25px;
		}

		.select_value {
			margin: 10px 0 0;
			color: #040404;
			line-height: 25px;
			cursor: pointer;
			padding: 0 30px;
		}

		.select_value.active {
			font-weight: 700;
			color: #3d7efe;
		}

		.value_wrap {
			.select_value {
				// margin-top: 5px;
				margin-bottom: 14px;
			}
		}

		.selected_box {
			margin: 0 25px 0 0;
			padding: 0 23px;
			height: 44px;
			border-radius: 8px;
			border: 2px solid #3d7efe;

			.value {
				font-weight: 700;
				line-height: 25px;

				.icon_del {
					margin-left: 10px;
					display: block;
					width: 20px;
					height: 20px;
					background-image: url(@/assets/static/icon/z_icon_delete1.png);
					background-size: 20px;
					background-repeat: no-repeat;
					cursor: pointer;
				}

				div {
					color: #3d7efe;
				}
			}

			.value + .value {
				margin-left: 10px;
			}

			.key {
				color: #040404;
				line-height: 25px;
			}
		}

		.btn_toggle {
			position: relative;
			padding: 0 0 0 18px;
			width: 115px;
			height: 42px;
			border-radius: 8px;
			border: 2px solid #969696;
			line-height: 38px;
			cursor: pointer;
		}

		.btn_toggle::after {
			content: "";
			position: absolute;
			right: 18px;
			top: 50%;
			transform: translateY(-50%);
			display: block;
			width: 11px;
			height: 11px;
			background-image: url(@/assets/static/icon/z_icon_down1.png);
			background-repeat: no-repeat;
			background-size: 11px;
		}

		.btn_toggle.active {
			padding-left: 27px;
		}

		.btn_toggle.active::after {
			transform: translateY(-35%) rotate(180deg);
		}
	}

	.rank_row {
		padding: 0 10px;
		line-height: 50px;
		background: rgba(61, 126, 254, 0.04);

		.rank {
			margin-right: 110px;
			color: #040404;
			line-height: 25px;
			text-align: left;
			font-style: normal;
			cursor: pointer;

			div {
				color: #040404;
			}

			.icon_rank {
				margin-left: 2px;
				display: block;
				width: 18px;
				height: 18px;
			}
		}

		.rank.active {
			color: #3d7efe;
			font-weight: 700;

			div {
				color: #3d7efe;
			}
		}

		.total {
			span {
				color: #040404;
			}

			.num {
				margin: 0 2px;
				color: #3d7efe;
				font-weight: 700;
			}
		}
	}

	.products_wrap {
		// padding: 0 0 100px;
		padding: 0 0 0.2rem;

		.product_item {
			margin: 20px 20px 0 0;
			padding: 20px 22px;
			display: block;
			// width: 260px;
			width: 272px;
			min-height: 416px;
			background: #ffffff;
			border-radius: 8px;
			cursor: pointer;
			box-shadow: 0px 0px 30px 0px rgba(218, 227, 234, 0.5), 0px 0px 10px 0px rgba(218, 227, 234, 0.5);

			.img1 {
				margin: 0 auto 14px;
				display: block;
				width: 100%;
				height: 228px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid rgba(98, 134, 171, 0.2);
			}

			.price1 {
				margin: 0 0 4px;
				font-weight: normal;
				color: #eb3f25;
				line-height: 26px;
			}

			.price2 {
				font-weight: 700;
				color: #eb3f25;
				line-height: 31px;
			}

			.price3 {
				color: #eb3f25;
				line-height: 22px;
			}

			.name {
				margin: 0 0 8px;
				font-weight: 700;
				color: #272727;
				line-height: 31px;
			}

			.spec {
				font-weight: normal;
				color: #969696;
				line-height: 24px;
			}
		}

		.product_item:hover {
			transform: translateY(-10px);
		}

		.product_item:nth-of-type(5n) {
			margin: 24px 0 0;
		}
	}

	.page_wrap {
		.page_item {
			margin-right: 14px;
			padding: 0 13px;
			height: 36px;
			border-radius: 8px;
			border: 1px solid #969696;
			color: #040404;
			line-height: 36px;
			text-align: center;
			font-style: normal;
			cursor: pointer;
		}

		.page_item.active {
			background: #3d7efe;
			color: #ffffff;
			border-color: #3d7efe;
		}

		.page_dot {
			margin-right: 14px;
			margin-top: -10px;
			color: #040404;
			font-weight: 700;
		}

		.icon_arrow {
			display: inline-block;
			width: 8px;
			height: 14px;
			line-height: 36px;
		}

		.text_go {
			padding-right: 4px;
			padding-left: 30px;
			color: #969696;
			line-height: 20px;
		}

		.input_go {
			margin-right: 14px;
			padding: 0;
			width: 51px;
			height: 36px;
			border-radius: 8px;
			border: 1px solid #969696;
			color: #040404;
			line-height: 36px;
			text-align: center;
		}

		.btn_go {
			width: 36px;
			height: 36px;
			background: rgba(61, 126, 254, 0.06);
			border-radius: 8px;
			color: #3d7efe;
			line-height: 36px;
			text-align: center;
			font-style: normal;
			cursor: pointer;
		}
	}

	.pagination1 {
		position: relative;
		padding: 0;
		.pagination{
			padding-top: 0;
			padding-bottom: 0.2rem;
		}
	}
	.icon_cart {
		width: 52px;
		height: auto;
	}

	@media screen and (max-width: 1440px) {
		.products_wrap {
			.product_item {
				width: 240px;
				padding: 20px;
				min-height: 390px;
			}
			.product_item .img1 {
				height: 200px;
			}
		}
	}
</style>
